export default {
  address: 'Adresse',
  contact: 'Kontakt',
  terms: 'Brugsvilkår',
  privacy_policy: 'Privatlivspolitik',
  impressum: 'Impressum',
  cookie_policy: 'Cookiepolitik',
  cookie_settings: 'Cookieindstillinger',
};
